import { Injectable, Signal, signal } from '@angular/core';
import { MenuItem } from './types';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  public readonly breadcrumbs: Signal<MenuItem[]>;
  private readonly _breadcrumbs = signal<MenuItem[]>([]);

  constructor() {
    this.breadcrumbs = this._breadcrumbs.asReadonly();
  }

  public set(items: MenuItem[]) {
    this._breadcrumbs.set(items);
  }

  public updateLastLabel(label: string) {
    this._breadcrumbs.update((items) => {
      items[items.length - 1].label = label;
      return [...items];
    });
  }

  public patchById(id: string, patchValues: MenuItem) {
    this._breadcrumbs.update((items) => {
      const index = items.findIndex((item) => item.id === id);

      if (index >= 0) {
        items[index] = {
          ...items[index],
          ...patchValues,
        };
      }

      return [...items];
    });
  }
}
